import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SrFlagIcon } from '../images/srb.svg';
import { ReactComponent as EnFlagIcon } from '../images/eng.svg';
import './LanguageSelector.css';

export const LanguageSelector = () => {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const currentLanguage = i18n.language;

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="lang-selector" ref={ref}>
            <button className="lang-toggle" onClick={() => setOpen(!open)}>
                {currentLanguage === 'en'
                    ? <EnFlagIcon width={18} height={18} />
                    : <SrFlagIcon width={18} height={18} />
                }
                <span className="lang-label">{currentLanguage === 'en' ? 'ENG' : 'SRP'}</span>
                <span className={`lang-arrow ${open ? 'open' : ''}`}>▾</span>
            </button>
            {open && (
                <div className="lang-menu">
                    <button className="lang-option" onClick={() => changeLanguage('en')}>
                        <EnFlagIcon width={18} height={18} />
                        <span>English</span>
                    </button>
                    <button className="lang-option" onClick={() => changeLanguage('sr')}>
                        <SrFlagIcon width={18} height={18} />
                        <span>Srpski</span>
                    </button>
                </div>
            )}
        </div>
    );
};
